module.exports = __webpack_public_path__ + "assets/img/5a092405a4ff2382d4e7294996b45aeb.png";